import classes from "../classes";
import EntrantPicksPopup from "./entrant-picks-popup";
import { List } from "immutable";
import pure from "./higher-order/pure";
import RaceCountdown from "./race-countdown";
import React from "react";
import TowelIcon from "./towel-icon";

export default pure(function PlayFieldResults({ bets, number, race, raceEntrants, tickets, tournament, users }) {
  if (race.get("status") === "running") {
    return <ResultsRunning number={number} />;
  }
  if (race.get("status") === "cancelled") {
    return <ResultsCancelled />;
  }
  if (!race.get("race_result")) {
    return <ResultsCountdown race={race} />;
  }
  var betType = tournament.get("bet_type");
  var result = race.get("race_result");

  var entrants = race.get("race_entrants").map((id) => raceEntrants.get(id));

  var results = List(["first", "second", "third"]).flatMap((position) => {
    return result.get(position).map(lane => ({ lane, position }));
  }).map(winner => (
    <Result
      betType={betType}
      bets={bets}
      key={winner.position + "-" + winner.lane}
      lane={winner.lane}
      position={winner.position}
      race={race}
      raceEntrants={entrants}
      result={result}
      tickets={tickets}
      tournament={tournament}
      users={users} />
  ));

  return (
    <div className="game-table_cell game-table_cell--results">
      <div className="game-table_results-table">
        {results}
      </div>
    </div>
  );
});

function ResultsCountdown({ race }) {
  return (
    <div className="game-table_cell game-table_cell--results">
      <div className="game-table_status">
        <span className="game-summary_label">
          <RaceCountdown race={race} />
        </span>
      </div>
    </div>
  );
}

function ResultsCancelled() {
  return (
    <div className="game-table_cell game-table_cell--results">
      <div className="game-table_status color--is-red">
        <i className="dw-blocked dw--1-25x" />

        <span className="game-summary_label">
          {" "}
          Race Cancelled
        </span>
      </div>
    </div>
  );
}

function ResultsRunning({ number }) {
  return (
    <div className="game-table_cell game-table_cell--results">
      <div className="game-table_status">
        <span className="color--is-lime tooltip" data-tooltip={"Race " + number + " is now Running."}>
          <span className="dw-horse-running dw--1-25x" />

          <span className="game-summary_label">
            {" "}
            Running
          </span>
        </span>
      </div>
    </div>
  );
}

function Result({ betType, bets, lane, position, race, raceEntrants, result, tickets, tournament, users }) {
  if (tournament.get("tournament_type") === "Survivor") {
    betType = "WPS";
  }
  var raceEntrant = raceEntrants.filter((e) => e && e.get("lane_number") === lane).first();
  if (!raceEntrant) {
    return null;
  }

  var betsForRace = bets.get(race.get("id"));
  if (!betsForRace) {
    return null;
  }
  var betIdsForEntrant = tournament.getIn(["picks", raceEntrant.get("id").toString()]) || List();
  var betsForEntrant = betIdsForEntrant.map(betId => betsForRace.get(betId));
  var picks = betsForEntrant
    .map((bet) => tickets.find((t) => t && bet && t.get("id") === bet.get("ticket_id")))
    .filter(t => t)
    .sort((a, b) => a.get("rank") - b.get("rank"));

  var deadHeat = false; // FIXME

  var positionToNumber = {
    "first": 1,
    "second": 2,
    "third": 3
  };
  var numericPosition = positionToNumber[position];

  var places = ["win", "place", "show"];
  var wps = ["W", "P", "S"];
  var scores = places.map((place, i) => (
    <div className="game-table_results-cell" key={place}>
      <span className={classes({
        "text--is-bold": true,
        "color--is-light-gray": betType.indexOf(wps[i]) === -1
      })}>
        {numericPosition <= i + 1 ? result.getIn(["odds", lane.toString(), place]) : null}
      </span>
    </div>
  ));

  return (
    <div className="game-table_results-row">
      <div className="game-table_results-cell">
        <EntrantPicksPopup deadHeat={deadHeat} position={position} raceEntrant={raceEntrant} tickets={picks} users={users}>
          <ul className="game-table_horse-group">
            <li>
              <TowelIcon lane={lane} small />
            </li>

            <li>
              <div className="game-table_horse-name">
                {raceEntrant.get("horse_name")}
              </div>
            </li>
          </ul>
        </EntrantPicksPopup>
      </div>

      {scores}
    </div>
  );
}
